import {
  FC, useEffect, useState,
} from 'react';
import { TripCartAttentionField } from 'src/listing/types';
import { useTripCartOptionsContext } from 'src/trip-cart/hooks/useTripCartOptionsContext';
import styles from './Attention.module.scss';

type AttentionProps = {
  field: TripCartAttentionField;
};

const TripCartAttention: FC<AttentionProps> = ({ field }) => {
  const { attentionFields, removeAttentionField, optionsLoading } = useTripCartOptionsContext();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (optionsLoading) return;

    const hasAttention = attentionFields.includes(field);
    if (hasAttention) {
      setVisible(true);
      removeAttentionField(field);
    }
  }, [attentionFields, field, optionsLoading, removeAttentionField]);

  if (!visible) return null;

  return <div className={styles.root} onAnimationEnd={() => setVisible(false)} />;
};

export default TripCartAttention;
